module.exports = __webpack_public_path__ + "static/header_bg_4-4f24f6775f8926b8fc0146dd501022a5.png";